<template>
  <div class="record-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">用户身份：</div>
              <el-select
                v-model="filter.level"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in role"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">开通时间：</div>
              <el-date-picker
                v-model="date"
                type="datetimerange"
                align="right"
                unlink-panels
                class="date-input"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                size="small"
              >
              </el-date-picker>
            </div>
            <!-- <div class="filter-item">
              <div class="label">用户手机号：</div>
              <el-input
                class="input"
                v-model="filter.phone"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div> -->
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <!-- <div>
            <button class="import-btn" @click="record2excel">导出操作记录</button>
          </div> -->
        </div>
        <!-- 表格 -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column prop="oldLevel" align="center" label="原团队等级">
            <div slot-scope="scope">
              {{ roleMap[scope.row.oldLevel] }}
            </div>
          </el-table-column>
          <el-table-column prop="areaName" align="center" label="原团队等级">
            <div slot-scope="scope">
              {{ roleMap[scope.row.newLevel] }}
            </div>
          </el-table-column>
          <el-table-column prop="created" align="center" label="开通时间">
            <div slot-scope="scope">
              {{ scope.row.created | dateFormat }}
            </div>
          </el-table-column>
          <!-- <el-table-column prop="created" align="center" label="关闭时间">
            <div slot-scope="scope">
              {{ scope.row.closedTime | dateFormat }}
            </div>
          </el-table-column> -->
          <el-table-column prop="operator" align="center" label="操作人"></el-table-column>
          <el-table-column prop="remark" align="center" label="操作类型"></el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
// import dayjs from 'dayjs';
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import { level, levelMap } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'record',
  data() {
    return {
      currentPage: 1, // 当前页码
      totalPage: 1,
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '团队等级开通记录'
      },
      filter: {
        level: 0,
        uid: null
      },
      role: [
        {
          name: '全部',
          id: 0
        },
        ...level
      ],
      roleMap: levelMap,
      wayMap: {
        1: '后台开通代理商身份',
        2: '后台关闭代理商身份',
        3: '到期自动关闭代理商身份'
      },
      list: [],
      showProgressDialog: false,
      progress: 0,
      date: []
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '';
      // let day = dayjs(date);
      // return day.format('YYYY-MM-DD HH:mm:ss');
      return date;
    }
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取留言板列表
    getList() {
      // return;
      this.filter.start = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      this.loading++;
      this.httpGet(this.$root.agentRecordNew, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
          this.totalPage = Math.ceil(res.total / this.size);
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        level: 0,
        uid: null
      };
      this.date = [];
      this.getList();
    },
    async record2excel() {
      let List = [];
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(List).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(List);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(list) {
      for (let i = 1; i <= this.totalPage; i++) {
        let data = {
          size: this.size,
          ...this.filter,
          page: i
        };
        await this.httpGet(this.$root.agentRecord, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / this.totalPage) * 100);
          console.log('page' + i, list.length);
        });
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          被操作用户ID: item.uid,
          用户昵称: item.nickname,
          注册电话: item.phone,
          原身份: this.roleMap[item.oldRole],
          现身份: this.roleMap[item.newRole],
          操作内容: item.remark,
          操作时间: item.created
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.record-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
      }

      .import-btn {
        confirm-btn();
        height: 32px;
        padding: 0 15px;
        white-space: nowrap;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();

    .notice-input {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
